<template>
  <div class="modal-frame modal-medium" :class="{active:isOpen}" data-modal="table-settings">
    <div class="modal-frame-content">
      <button @click="$emit('close')" class="btn-close" rel="button_close" type="button" data-modal-close>
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header">
        <div class="h3">{{ t('actions.columnSettings') }}</div>
      </div>
      <div class="modal-frame-body">
        <form class="table-settings" @submit.prevent="apply">
          <div class="table-settings-content py-30 border-block">
            <label
                v-for="item in items"
                :key="item.key"
                class="checkbox-label"
            >
              <input
                  type="checkbox"
                  :name="`column_${item.key}`"
                  :checked="localSelected.includes(item.key)"
                  @change="toggleColumn(item.key, $event.target.checked)"
              >
              <span class="fake-checkbox"></span>
              <span class="checkbox-name">{{ item.label }}</span>
            </label>
          </div>
          <div class="form-footer pt-20">
            <div class="buttons-row flex-center pb-30">
              <button class="link-dotted" type="button" @click="selectAll">{{ t('settings.selectAll') }}</button>
              <button class="link-dotted" type="button" @click="clearAll">{{ t('settings.clearAll') }}</button>
            </div>
            <div class="buttons-row">
              <button class="btn w-100" type="submit" :disabled="!canApply">{{ t('modals.apply') }}</button>
              <button @click="$emit('close')" class="btn-outline w-100" type="button">{{ t('modals.cancel') }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'apply'],
  data: () => ({
    localSelected: [],
  }),
  setup() {
    const { t } = useI18n();
    return { t };
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetLocalSelected();
        }
      },
    },
    selected() {
      if (this.isOpen) {
        this.resetLocalSelected();
      }
    },
  },
  computed: {
    canApply() {
      return this.localSelected.length > 0;
    },
  },
  methods: {
    resetLocalSelected() {
      this.localSelected = [...this.selected];
    },
    toggleColumn(key, checked) {
      if (checked && !this.localSelected.includes(key)) {
        this.localSelected.push(key);
      }
      if (!checked) {
        this.localSelected = this.localSelected.filter(item => item !== key);
      }
    },
    selectAll() {
      this.localSelected = this.items.map(item => item.key);
    },
    clearAll() {
      this.localSelected = [];
    },
    apply() {
      if (!this.canApply) {
        return;
      }
      this.$emit('apply', [...this.localSelected]);
    },
  },
}
</script>
